/* eslint-disable no-undef */
class ProductGallery extends HTMLElement {
  connectedCallback() {
    this.thumbnails = this.querySelector('[data-thumbnails]');
    this.container = document.querySelector('[data-variant-gallery-container]');
    window.addEventListener('load', () => {
      this.init();
      this.container.addEventListener('theme:gallery:reinit', (event) => {
            this.init();
      });
    });

    this.slides = [...this.querySelectorAll('.gallery-slide')];
    this.slides.forEach(el => el.addEventListener('click', (e) => {
        if(this.classList.contains('modal')){
          this.toggleSliderArrows(true); // Show instagram slider arrows when modal is closed
          this.classList.toggle('zoom-in');
          if(this.classList.contains('zoom-in')){
            this.toggleSliderArrows(false); // Hide instagram slider arrows when modal is opened and you zoom
            this.main.zoom.in();
          }else{
            this.toggleSliderArrows(false); // Hide instagram slider arrows when modal is opened and you zoom back out
            this.main.zoom.out();
          }

        }else{
          this.classList.add('modal');
          this.sliderArrows = document.querySelectorAll('.slider-arrow');
          this.toggleSliderArrows(false); // Hide instagram slider arrows when modal is opened
        }

    }));
    this.overlay = [...this.querySelectorAll('.product-gallery-overlay')];
    this.overlay.forEach(el => el.addEventListener('click', (e) => {
        this.classList.toggle('modal');
        this.toggleSliderArrows(true); // Show instagram slider arrows when modal is closed
    }));

    this.thumbnails.querySelectorAll('.swiper-slide').forEach(el => el.addEventListener('click', (e) => {
      // console.log(el.dataset.index)
      this.main.slideTo(Number(el.dataset.index) - 1);
    }));
  }

  init(){
      // this.thumbSlider = new Swiper('[data-thumbnails]', {
      //   slidesPerView: 5,
      //   spaceBetween: 0,
      //   grid: {
      //     rows: 2,
      //   },
      // });
      this.main = new Swiper('[data-main-gallery]',{
        spaceBetween: 10,
        navigation: false,
        zoom: true,
        allowTouchMove: true,
        navigation: {
            nextEl: '[data-swiper-button-next]',
            prevEl: '[data-swiper-button-prev]',
        }


      });
      // if(this.thumbSlider.slides.length > 1){
      //     document.querySelector('[data-thumbnails]').classList.remove('opacity-0');
      // }
  }

  toggleSliderArrows(show) {
    if (this.sliderArrows.length > 0) {
      for (var i = 0; i < this.sliderArrows.length; i++) {
        this.sliderArrows[i].style.display = show ? 'block' : 'none';
      }
    }
  }
}
customElements.define('product-gallery', ProductGallery);
